import { createReducer } from '@reduxjs/toolkit'
import { communitySort, marketSort, sortFloorPrice, sortNumber, volumeSort, sort_user_likes } from '../../helper/helper'
import { ALL_PROJECTS, COMMUNITY, FLOOR_PRICE, HYPE, LIKE_PROJECT, LOGIN, MARKET_CAP, SORT_NUMBER, SORT_USER_LIKES, SUPPLY, UPCOMING_PROJECTS, VENTORY_PROJECTS, VOLUME_HS } from '../actions/actions'

const initialState = {
    mintedProjects: [],
    upcomingProjects: [],
    likedProjects: [],
    user: { ok: false },
    ventoryProjects: []
}

export const clientReducer = createReducer(initialState, (callback) => {
    callback.addCase(ALL_PROJECTS.fulfilled, (state, action) => {
        let projects = action.payload.projects
        projects.sort((a, b) => {
            if (!a.hype && !b.hype) return 0
            else if (!a.hype) return 1
            else if (!b.hype) return -1
            else return b.hype - a.hype
        })
        // state.mintedProjects = action.payload.ok ? action.payload.projects : ""
        state.mintedProjects = projects

    })

    callback.addCase(VENTORY_PROJECTS.fulfilled, (state, action) => {
        let projects = action.payload.projects
        state.ventoryProjects = projects
    })

    callback.addCase(UPCOMING_PROJECTS.fulfilled, (state, action) => {
        state.upcomingProjects = action.payload.ok ? action.payload.projects : ""
    })

    callback.addCase(HYPE.fulfilled, (state, action) => {
        if (action.payload === "minted") {
            let projects = state.mintedProjects
            projects.sort((a, b) => {
                if (!a.hype && !b.hype) return 0
                else if (!a.hype) return 1
                else if (!b.hype) return -1
                else return b.hype - a.hype
            })
            state.mintedProjects = projects
        } else if (action.payload === "upcoming") {
            let projects = state.upcomingProjects
            projects.sort((a, b) => {
                if (!a.hype && !b.hype) return 0
                else if (!a.hype) return 1
                else if (!b.hype) return -1
                else return b.hype - a.hype
            })
            state.upcomingProjects = projects
        }
    })
    callback.addCase(COMMUNITY.fulfilled, (state, action) => {
        if (action.payload === "minted") {
            let projects = state.mintedProjects
            let sortedProjects = communitySort(projects)
            state.mintedProjects = sortedProjects
        } else if (action.payload === "upcoming") {
            let projects = state.upcomingProjects
            let sortedProjects = communitySort(projects)
            state.upcomingProjects = sortedProjects
        }
    })

    callback.addCase(SORT_NUMBER.fulfilled, (state, action) => {
       let projects = state.ventoryProjects
       let sortedProjects = sortNumber(projects, action.payload)
       state.ventoryProjects = sortedProjects
    })
    callback.addCase(MARKET_CAP.fulfilled, (state, action) => {
        let projects = state.mintedProjects
        let sortedProjects = marketSort(projects)
        state.mintedProjects = sortedProjects
    })
    callback.addCase(VOLUME_HS.fulfilled, (state, action) => {
        let projects = state.mintedProjects
        let sortedProjects = volumeSort(projects)
        state.mintedProjects = sortedProjects
    })
    callback.addCase(SUPPLY.fulfilled, (state, action) => {
        let projects = state.mintedProjects
        projects.sort((a, b) => {
            if (a.supply === "???") return 1
            else if (b.supply === "???") return -1
            else return b.supply - a.supply
        })
        state.mintedProjects = projects
    })
    callback.addCase(FLOOR_PRICE.fulfilled, (state, action) => {
        let projects = state.mintedProjects
        let sortedProjects = sortFloorPrice(projects)
        state.mintedProjects = sortedProjects
    })
    callback.addCase(LIKE_PROJECT.fulfilled, (state, action) => {
        let likedProjectId = action.payload
        let likedProjects = state.likedProjects
        let allProjects = state.mintedProjects
        console.log({ allProjects })
        let projectLikedIndex = allProjects.findIndex((project) => project._id === likedProjectId)
        let user = state.user
        if (allProjects[projectLikedIndex].userLikes.includes(user?.id)) {
            let userLikes = allProjects[projectLikedIndex].userLikes.filter((userIds) => userIds != state.user.id)
            allProjects[projectLikedIndex].userLikes = userLikes
            state.upcomingProjects = allProjects

            let dislikeArr = likedProjects.filter((nameProject) => nameProject != likedProjectId)
            console.log(dislikeArr)
            state.likedProjects = dislikeArr

        } else {
            allProjects[projectLikedIndex].userLikes.push(state.user.id)
            state.upcomingProjects = allProjects
            likedProjects.push(likedProjectId)
            console.log(likedProjects)
            state.likedProjects = likedProjects
        }
    })

    callback.addCase(LOGIN.fulfilled, (state, action) => {
        console.log(action.payload)
        let userRes = {
            ok: action.payload.ok,
            id: action.payload.id
        }
        state.user = userRes
        state.likedProjects = action.payload.projectsLiked
    })
    callback.addCase(SORT_USER_LIKES.fulfilled, (state, action) => {
        let allProjects = state.mintedProjects
        let projectsOrdenados = sort_user_likes(allProjects)
        state.mintedProjects = projectsOrdenados
    })
})